import {isAnonymous} from 'topmeteo/utils/html';

import {ScrollDirection, ComputeStyle} from '../ScrollWatch';
import {PanelHeight, ScrollingElement} from '../base';

import Table from './Table';

const defaultTop = isAnonymous ? 40 : 0;

const verticalScroll = ({scrollLeft}) => ({
    position: 'absolute',
    left: scrollLeft,
    top: 0,
});

const horizontalScroll = ({scrollTop}, panelOpen) => ({
    position: 'fixed',
    left: 0,
    top: defaultTop + (panelOpen ? PanelHeight.open : PanelHeight.closed) - scrollTop,
});

const getComputedStyle = ({scrollDirection, node, panelOpen}) => (
    scrollDirection === ScrollDirection.horizontal
        ? horizontalScroll(ScrollingElement, panelOpen)
        : verticalScroll(node)
);

const Wrapper = props => (
    <ComputeStyle {...props} getComputedStyle={getComputedStyle}>
        <Table />
    </ComputeStyle>
);

export default Wrapper;
